<!-- ===================== Filter Bar ===================== -->
@if (filterLoading) {
<div class="gt-filter-container">
  <div class="col">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
</div>
}

@if (!filterLoading) {
<div class="gt-filter-container ng-scope">
  <div class="col">
    <select id="ftc_schd_j_tax_year"
      [(ngModel)]="selectedTaxYear"
      (ngModelChange)="getScenarioDropDown()">
      @for (item of filteredTaxYearData; track $index) {
<option [ngValue]="item">{{ item.label }}</option>
}
    </select>
  </div>
  <div class="col">
    @if (scenarioLoading) {
<div class="gt-filter-loading ng-hide" style="width: 140px;">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
}
    @if (!scenarioLoading) {
<select id="ftc_schd_j_scenario"
     
      [(ngModel)]="selectedScenario"
      (ngModelChange)="getFilingGroupDropdown()">
      @for (item of scenarioDropDown; track $index) {
<option [ngValue]="item">{{ item.LABEL }}</option>
}
    </select>
}
  </div>
  <div class="col">
    @if (filingGrpLoading) {
<div class="gt-filter-loading ng-hide" style="width: 140px;">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
}
    @if (!filingGrpLoading) {
<select id="ftc_schd_j_fg"
     
      [(ngModel)]="selectedFG"
      (ngModelChange)="getFilerEntityDropdown()">
      @for (item of filingGroupDropdown; track $index) {
<option [ngValue]="item">{{ item.LABEL }}</option>
}
    </select>
}
  </div>
  <div class="col">
    @if (filerEntityLoading) {
<div class="gt-filter-loading ng-hide" style="width: 140px;">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
}
    @if (!filerEntityLoading) {
<select id="ftc_schd_j_fe"
     
      [(ngModel)]="selectedFE">
      @for (item of filerEntityDropdown; track $index) {
<option [ngValue]="item">{{ item.FILER_LE }}</option>
}
    </select>
}
  </div>
  <div class="col">
    <div class="btn btn-xs btn-success" (click)="refresh()">Filter</div>
  </div>
</div>
}

<!-- Banner (no data loaded yet) -->
@if (showBanner) {
<div class="gg-loader">
  <div class="gg-loader-text">
    <img src="assets/img/arrow-filter-sm.png" alt="Filter">
  </div>
</div>
}

<!-- Form Content -->
@if (!showBanner) {
<div style="background-color:white">
  <!-- Spinner -->
  @if (showSpinner) {
<div class="text-center" style="padding: 40px;">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}

  @if (!showSpinner) {
<div class="divShadow">

    <!-- ===================== Schedule J Part I ===================== -->
    <p class="h4"><b>Part I:</b> Adjustments to Separate Limitation Income or (Losses) in Determining Numerators
      of Limitation Fractions (see instructions)</p>
    <div class="table-responsive" style="position: relative;left:1px;width:100%">
      <table class="table table-striped blue">
        <thead>
          <tr align="center">
            <th>&nbsp;#&nbsp;</th>
            <th>&nbsp;&nbsp;</th>
            @for (cols of formColumnsPartI; track $index) {
<th style="width:100px;text-align: center;vertical-align: top;"
               >
              {{ cols.CODE_DESC + ' ' + cols.CODE_DISP_DESC }}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of groupedFormLines; track trackByLineOrder($index, x)) {
<tr>
            <td style="font-weight:bold">{{ x.LINE_NO }}</td>
            <td><p style="width:350px;">{{ x.LINE_DESCRIPTION }}</p></td>
            @for (amts of x.items; track trackByIndex(idx); let idx = $index) {
<td
                style="height: 30px; width:100px; text-align: right;">
              <!-- Editable field -->
              @if (amts.IS_ENABLED !== 'N') {
<input
                [id]="'FTC_SCHDJ_CRUD_I_' + x.LINE_ORDER + '_' + idx"
                class="form-control custom-textbox"
                [class.red-border]="amts.IS_ENABLED === 'Z'"
                [(ngModel)]="amts.ATTRIB_AMOUNT"
                (ngModelChange)="addTotals('I')"
                type="text"
                (focus)="onFieldFocus($event)"
                (blur)="onFieldBlur($event, amts, 'ATTRIB_AMOUNT')"
                (keypress)="onFieldKeypress($event)"
                (input)="onFieldInput($event, amts, 'ATTRIB_AMOUNT')"
                style="text-align: right;" />
}
              <!-- Read-only disabled field (subtotals / calculated lines) -->
              @if (amts.IS_ENABLED === 'N') {
<input
                [id]="'FTC_SCHDJ_RO_I_' + x.LINE_ORDER + '_' + idx"
                class="form-control custom-textbox"
                [value]="formatNumber(amts.ATTRIB_AMOUNT)"
                disabled
                type="text"
                style="text-align: right;" />
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- ===================== Schedule J Part II ===================== -->
    <p class="h4"><b>Part II:</b> Year-End Balances of Future Separate Limitation Income That
      Must Be Recharacterized (section 904(f)(5)(C))</p>
    <div class="table-responsive" style="position: relative;left:1px;width:100%">
      <table class="table table-striped blue">
        <thead>
          <tr align="center">
            <th>&nbsp;#&nbsp;</th>
            <th>&nbsp;&nbsp;</th>
            @for (cols of formColumnsPartII; track $index) {
<th style="width:100px;text-align: center;vertical-align: top;"
               >
              {{ cols.CODE_DESC + ' ' + cols.CODE_DISP_DESC }}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of groupedFormLinesPartII; track trackByLineOrder($index, x)) {
<tr>
            <td style="font-weight:bold">{{ x.LINE_NO }}</td>
            <td><p style="width:500px;">{{ x.LINE_DESCRIPTION }}</p></td>
            @for (amts of x.items; track trackByIndex(idx); let idx = $index) {
<td
                style="height: 30px; width:100px; text-align: right;">
              <!-- Editable field -->
              @if (amts.IS_ENABLED !== 'N') {
<input
                [id]="'FTC_SCHDJ_CRUD_II_' + x.LINE_ORDER + '_' + idx"
                class="form-control custom-textbox"
                [(ngModel)]="amts.ATTRIB_AMOUNT"
                (ngModelChange)="addTotals('II')"
                type="text"
                (focus)="onFieldFocus($event)"
                (blur)="onFieldBlur($event, amts, 'ATTRIB_AMOUNT')"
                (keypress)="onFieldKeypress($event)"
                (input)="onFieldInput($event, amts, 'ATTRIB_AMOUNT')"
                style="text-align: right;" />
}
              <!-- Read-only disabled field -->
              @if (amts.IS_ENABLED === 'N') {
<input
                [id]="'FTC_SCHDJ_RO_II_' + x.LINE_ORDER + '_' + idx"
                class="form-control custom-textbox"
                [value]="formatNumber(amts.ATTRIB_AMOUNT)"
                disabled
                type="text"
                style="text-align: right;" />
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- ===================== Schedule J Part III ===================== -->
    <p class="h4"><b>Part III:</b> Overall Foreign Loss Account Balances
      (section 904(f)(1)) Complete for each separate limitation income category.</p>
    <div class="table-responsive" style="position: relative;left:1px;width:100%">
      <table class="table table-striped blue">
        <thead>
          <tr align="center">
            <th>&nbsp;#&nbsp;</th>
            <th>&nbsp;&nbsp;</th>
            @for (cols of formColumnsPartIII; track $index) {
<th style="width:100px;text-align: center;vertical-align: top;"
               >
              {{ cols.CODE_DESC + ' ' + cols.CODE_DISP_DESC }}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of groupedFormLinesPartIII; track trackByLineOrder($index, x)) {
<tr>
            <td style="font-weight:bold">{{ x.LINE_NO }}</td>
            <td><p style="width:350px;">{{ x.LINE_DESCRIPTION }}</p></td>
            @for (amts of x.items; track trackByIndex(idx); let idx = $index) {
<td
                style="height: 30px; width:100px; text-align: right;">
              <!-- Editable field -->
              @if (amts.IS_ENABLED !== 'N') {
<input
                [id]="'FTC_SCHDJ_CRUD_III_' + x.LINE_ORDER + '_' + idx"
                class="form-control custom-textbox"
                [class.red-border]="amts.IS_ENABLED === 'Z'"
                [(ngModel)]="amts.ATTRIB_AMOUNT"
                (ngModelChange)="addTotals('III')"
                type="text"
                (focus)="onFieldFocus($event)"
                (blur)="onFieldBlur($event, amts, 'ATTRIB_AMOUNT')"
                (keypress)="onFieldKeypress($event)"
                (input)="onFieldInput($event, amts, 'ATTRIB_AMOUNT')"
                style="text-align: right;" />
}
              <!-- Read-only disabled field (subtotals / recapture lines) -->
              @if (amts.IS_ENABLED === 'N') {
<input
                [id]="'FTC_SCHDJ_RO_III_' + x.LINE_ORDER + '_' + idx"
                class="form-control custom-textbox"
                [value]="formatNumber(amts.ATTRIB_AMOUNT)"
                disabled
                type="text"
                style="text-align: right;" />
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- ===================== Schedule J Part IV ===================== -->
    <p class="h4"><b>Part IV:</b> Overall Domestic Loss Account Balances (section 904(g)(1))</p>
    <div class="table-responsive" style="position: relative;left:1px;width:100%">
      <table class="table table-striped blue">
        <thead>
          <tr align="center">
            <th>&nbsp;#&nbsp;</th>
            <th>&nbsp;&nbsp;</th>
            @for (cols of formColumnsPartIV; track $index) {
<th style="width:100px;text-align: center;vertical-align: top;"
               >
              {{ cols.CODE_DESC + ' ' + cols.CODE_DISP_DESC }}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of groupedFormLinesPartIV; track trackByLineOrder($index, x)) {
<tr>
            <td style="font-weight:bold">{{ x.LINE_NO }}</td>
            <td><p style="width:350px;">{{ x.LINE_DESCRIPTION }}</p></td>
            @for (amts of x.items; track trackByIndex(idx); let idx = $index) {
<td
                style="height: 30px; width:100px; text-align: right;">
              <!-- Editable field -->
              @if (amts.IS_ENABLED !== 'N') {
<input
                [id]="'FTC_SCHDJ_CRUD_IV_' + x.LINE_ORDER + '_' + idx"
                class="form-control custom-textbox"
                [class.red-border]="amts.IS_ENABLED === 'Z'"
                [(ngModel)]="amts.ATTRIB_AMOUNT"
                (ngModelChange)="addTotals('IV')"
                type="text"
                (focus)="onFieldFocus($event)"
                (blur)="onFieldBlur($event, amts, 'ATTRIB_AMOUNT')"
                (keypress)="onFieldKeypress($event)"
                (input)="onFieldInput($event, amts, 'ATTRIB_AMOUNT')"
                style="text-align: right;" />
}
              <!-- Read-only disabled field (subtotals / recapture lines) -->
              @if (amts.IS_ENABLED === 'N') {
<input
                [id]="'FTC_SCHDJ_RO_IV_' + x.LINE_ORDER + '_' + idx"
                class="form-control custom-textbox"
                [value]="formatNumber(amts.ATTRIB_AMOUNT)"
                disabled
                type="text"
                style="text-align: right;" />
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- ===================== Save / Reset Buttons ===================== -->
    <div class="row">
      <div class="col-md-4 col-md-offset-10">
        <button id="FTC_SCHDJ_CRUD_1" class="btn btn-info btn-sm"
          type="button"
          [disabled]="!isAdmin || isSaveClicked"
          style="margin-right: 8px;"
          (click)="saveGeneralBasket()">Save</button>
        <button id="FTC_SCHDJ_CRUD_2" class="btn btn-default btn-sm"
          type="button"
          [disabled]="!isAdmin"
          (click)="reset()">Reset</button>
      </div>
      <br /><br /><br />
    </div>
  </div>
}
  <br /><br /><br />
</div>
}

<!-- Confirmation Dialog (matches entity-update pattern) -->
@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <div class="confirmation-modal-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="modalConfig"
      [visible]="false"
      (confirmed)="onConfirmSave()"
      (cancelled)="onCancelConfirm()"
      (closed)="onCancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}